import axios from "axios";
import { config } from "../../Network_Calls/config";

const verifyAdmin = async () => {
  try {
    const response = await axios.get(
      process.env.REACT_APP_SERVER_URL + `/customer/verifyAdminorNot`,
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

const postEngagementTemplate = async (
  impl_id,
  template,
  Engage_id,
  name,
  Template_description
) => {
  console.log("sssssss", Engage_id);
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + "/customer/postEngagementTemplate",
      {
        impl_id: impl_id,
        template: template,
        Engag_id: Engage_id,
        name:name,
        description:Template_description
      },
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const getEngagementTemplate = async (impl_id, external_id) => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + "/customer/getEngagementTemplate",
      {
        impl_id: impl_id,
        external_id: external_id
      },
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const deleteEngagementTemplate = async (Engage_id) => {
  console.log("delete id ", Engage_id)
  try {
    const response = await axios.delete(
      process.env.REACT_APP_SERVER_URL + `/customer/deleteEngagementTemplate/${Engage_id}`,
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const templateVisitHistoryUpdate = async (id, external_id) => {
  //console.log("linkkkkkkkkkkkkkkkkkkkkkk visit history ", id)
  const response = await axios.post(
    process.env.REACT_APP_SERVER_URL + "/customer/templateVisitHistoryUpdate",
    {
      templateId:id,
      external_id:external_id
    },
    {
      ...config(),
    }
  );
  return response;
};

export {
  verifyAdmin,
  postEngagementTemplate,
  getEngagementTemplate,
  deleteEngagementTemplate,
  templateVisitHistoryUpdate
};
